const __component = document.querySelector('[ sticky-mobile-add-to-bag]');
const __quantity = __component.querySelector('.article-block__mobile-product-card--quantity');
const __quantityInput = __quantity.querySelector('[data-qty-input]');
const __minusControl = __quantity.querySelector('[data-qty-btn="minus"]');
const __plusControl = __quantity.querySelector('[data-qty-btn="plus"]');
const __addToBagButton = __component.querySelector('.article-block__mobile-product-card--add-to-bag[data-add-to-bag]');
const __addToBagSubsButton = __component.querySelector('.article-block__mobile-product-card--add-to-bag[data-add-to-bag-subscription]');

__minusControl?.addEventListener("click", function(control) {
    let __qty = Number(__quantityInput.value);
    let __minQty = Number(__quantityInput.min);
    if(__qty > __minQty) {
        __qty -= 1;
        __updateInputQty__(__quantityInput, __qty);
    }
    return __qty;
});

__plusControl?.addEventListener("click", function(control) {
    let __qty = Number(__quantityInput.value);
    __qty += 1;
    __updateInputQty__(__quantityInput, __qty);
    return __qty;
});

__addToBagButton?.addEventListener("click", function(button) {
    __addToBag__(button.target.dataset.variantId, __quantityInput.value, __component);
});

__addToBagSubsButton?.addEventListener("click", function(button) {
    __addToBagSubs__(button.target.dataset.variantId, button.target.dataset.variantSellingPlanId, __quantityInput.value, __component);
});

function __updateInputQty__(input, newQty) {
    input.value = newQty;
    return newQty;
}

function __addToBag__(variantId, quantity, component) {
    let item = {
        id: variantId,
        quantity: quantity
    }
    VueMinicart.config.globalProperties.$store.dispatch('addItem', item);
    __closeComponent__(component);
    return item;
}

function __addToBagSubs__(variantId, sellingPlanId, quantity, component) {
    let item = {
        id: variantId,
        selling_plan: sellingPlanId,
        quantity: quantity
    }
    VueMinicart.config.globalProperties.$store.dispatch('addItem', item);
    __closeComponent__(component);
    return item;
}

function __closeComponent__(component) {
    if(!component.classList.contains('hidden')) component.classList.add('hidden');
    return true;
}